'use client';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import BrandLogo from './BrandLogo';
import NavLink from '../NavLink';
import BookingButton from '../BookingButton';

export default function NavBar({ logoImages, navItems }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="bg-secondary/70 sticky top-0 z-50 w-full shadow-md backdrop-blur-md">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-8 py-2">
        <BrandLogo
          href="/"
          image={logoImages.madBadge.publicId}
          alt={logoImages.madBadge.alt}
          size={50}
        />
        <div className="laptop:flex laptop:gap-x-6 laptop:items-center hidden">
          {navItems.map((item) => (
            <NavLink key={item.name} href={item.href}>
              {item.name}
            </NavLink>
          ))}
          <BookingButton>Book Now</BookingButton>
        </div>
        <button
          className="hover:bg-secondary laptop:hidden text-secondary-foreground rounded p-2"
          onClick={() => setMobileOpen(true)}
          aria-label="Open menu"
        >
          <Bars3Icon className="h-6 w-6" />
        </button>
      </nav>

      <Dialog
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        className="laptop:hidden"
      >
        <DialogPanel className="bg-secondary/90 fixed inset-0 z-60 p-6 backdrop-blur-md">
          <div className="mb-6 flex items-center justify-between">
            <BrandLogo
              href="/"
              image={logoImages.madBadge.publicId}
              alt={logoImages.madBadge.alt}
              size={50}
            />
            <button
              onClick={() => setMobileOpen(false)}
              aria-label="Close menu"
            >
              <XMarkIcon className="h-6 w-6 text-white" />
            </button>
          </div>
          <nav className="mt-6 flex flex-col space-y-4">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                href={item.href}
                onClick={() => setMobileOpen(false)}
              >
                {item.name}
              </NavLink>
            ))}
          </nav>
          <div className="mt-6">
            <BookingButton>Book Now</BookingButton>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
